import axios from "../utils/axios.wrapper";

// Get all invoices
export const getAllInvoices = async () => {
  const { data } = await axios.get("/invoice");
  return data.items || data;
};

// Get invoice by ID
export const getInvoiceById = async (id) => {
  const { data } = await axios.get(`/invoice/${id}`);
  return data;
};

// Create new invoice
export const createInvoice = async (invoiceData) => {
  const { data } = await axios.post("/invoice/create", invoiceData);
  return data;
};

// Update invoice
export const updateInvoice = async (id, invoiceData) => {
  const { data } = await axios.put(`/invoice/${id}`, invoiceData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return data;
};

export const createAvoirFromInvoice = async ({ originalInvoiceId, avoirReason }) => {
  const { data } = await axios.post(
    `/invoice/create-avoir/${originalInvoiceId}`,
    { avoirReason },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};
 
export const createPassengerCashInvoice = async ({ shopId, amountToInvoice, businessDate }) => {
  const { data } = await axios.post("/invoice/create-passenger-cash-invoice", {
    shopId,
    amountToInvoice,
    businessDate,
  });
  return data;
};

export const getPassengerCashSummary = async ({ shopId, businessDate }) => {
  const { data } = await axios.post('/invoice/passenger-cash-summary', {
    shopId,
    businessDate,
  });
  return data;
};
// Soft delete invoice
export const softDeleteInvoice = async (id) => {
  const { data } = await axios.delete(`/invoice/${id}`);
  return data;
};

// Hard delete invoice
export const hardDeleteInvoice = async (id) => {
  const { data } = await axios.delete(`/invoice/hard/${id}`);
  return data;
};

// Get active invoices
export const getActiveInvoices = async () => {
  const { data } = await axios.get("/invoice/active");
  return data.items || data;
};

// Get inactive invoices
export const getInactiveInvoices = async () => {
  const { data } = await axios.get("/invoice/inactive");
  return data.items || data;
};

// Get invoices by customer ID
export const getInvoicesByCustomerId = async (customerId) => {
  const { data } = await axios.get(`/invoice/customer/${customerId}`);
  return data.items || data;
};

// Get invoices by customer name
export const getInvoicesByCustomerName = async (name) => {
  const { data } = await axios.get(`/invoice/customer/by-name/${name}`);
  return data.items || data;
};

// Get invoices by date range
export const getInvoicesByDateRange = async (startDate, endDate) => {
  const { data } = await axios.post("/invoice/daterange", { startDate, endDate });
  return data.items || data;
};

// Get invoices paginated
export const getInvoicesPaginated = async (filter) => {
  const { data } = await axios.post("/invoice/paginate", filter);
  return data;
};

export const createEndOfDayPassengerInvoices = async ({ shopId, businessDate }) => {
  const { data } = await axios.post("/invoice/create-end-of-day-passenger-invoices", {
    shopId,
    businessDate,
  });
  return data.items || data;
};

export const invoiceService = {
  getAllInvoices,
  getInvoiceById,
  createInvoice,
  updateInvoice,
  softDeleteInvoice,
  hardDeleteInvoice,
  getActiveInvoices,
  getInactiveInvoices,
  getInvoicesByCustomerId,
  getInvoicesByCustomerName,
  getInvoicesByDateRange,
  getInvoicesPaginated,
  createEndOfDayPassengerInvoices,
  createAvoirFromInvoice,
  createPassengerCashInvoice,
  getPassengerCashSummary,
};
